(function () {
  const petLimit = 3;

  const petList = document.getElementById("petList");
  const modal = document.getElementById("petModal");
  const addPetBtn = document.getElementById("addPetBtn");
  const closeModalBtn = document.getElementById("closeModal");
  const savePetBtn = document.getElementById("savePet");

  const modalTitle = document.getElementById("petModalTitle");
  const editIndexInput = document.getElementById("petEditIndex");

  const nameInput = document.getElementById("petName");
  const neckInput = document.getElementById("petNeck");
  const birthMonthInput = document.getElementById("petBirthMonth");
  const birthMonthNote = document.getElementById("birthMonthNote");
  const photoInput = document.getElementById("petPhoto");

  if (!petList || !modal || !addPetBtn || !closeModalBtn || !savePetBtn) return;
  if (!window.kiokattCustomer || !window.kiokattCustomer.id) return;

  let pets = [];

  async function loadPets() {
    try {
      const res = await fetch(`/apps/kiokatt-pet-profiles/api/pets?customerId=${encodeURIComponent(window.kiokattCustomer.id)}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      });

      if (!res.ok) throw new Error("Failed to load pets");

      const data = await res.json();
      pets = Array.isArray(data.pets) ? data.pets : [];
      renderPets();
    } catch (error) {
      console.error(error);
      pets = [];
      renderPets();
    }
  }

  async function savePetsToCustomer() {
    const res = await fetch(`/apps/kiokatt-pet-profiles/api/pets`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        customerId: window.kiokattCustomer.id,
        pets: pets
      })
    });

    if (!res.ok) {
      throw new Error("Failed to save pets");
    }

    return res.json();
  }

  function openModal() {
    modal.style.display = "flex";
  }

  function closeModal() {
    modal.style.display = "none";
    editIndexInput.value = "";
    modalTitle.textContent = "Add Pet";
    nameInput.value = "";
    neckInput.value = "";
    birthMonthInput.value = "";
    birthMonthInput.disabled = false;
    birthMonthNote.style.display = "none";
    photoInput.value = "";
  }

  function renderPets() {
    petList.innerHTML = "";
    addPetBtn.style.display = pets.length >= petLimit ? "none" : "inline-flex";

    pets.forEach(function (pet, index) {
      const card = document.createElement("div");
      card.className = "pet-card";

      card.innerHTML = `
        <img src="${pet.photo || ""}" alt="${escapeHtml(pet.name)}">
        <strong>${escapeHtml(pet.name)}</strong>
        <div>Neck: ${escapeHtml(pet.neck || "-")}</div>
        <div>Birth Month: ${escapeHtml(pet.birthMonth || "-")}</div>
        <div class="pet-actions">
          <button type="button" class="try-collars-btn" data-index="${index}">Try Collars</button>
          <button type="button" class="edit-pet-btn" data-index="${index}">Edit</button>
          <button type="button" class="remove-pet-btn" data-index="${index}">Remove</button>
        </div>
      `;

      petList.appendChild(card);
    });

    bindCardActions();
  }

  function bindCardActions() {
    document.querySelectorAll(".try-collars-btn").forEach(function (btn) {
      btn.onclick = function () {
        alert("Try-on editor coming next");
      };
    });

    document.querySelectorAll(".edit-pet-btn").forEach(function (btn) {
      btn.onclick = function () {
        const index = Number(this.getAttribute("data-index"));
        openEditModal(index);
      };
    });

    document.querySelectorAll(".remove-pet-btn").forEach(function (btn) {
      btn.onclick = async function () {
        const index = Number(this.getAttribute("data-index"));
        const pet = pets[index];
        if (!pet) return;

        const confirmed = window.confirm(`Remove ${pet.name}?`);
        if (!confirmed) return;

        pets.splice(index, 1);

        try {
          await savePetsToCustomer();
          renderPets();
        } catch (error) {
          console.error(error);
          alert("Could not remove pet right now.");
        }
      };
    });
  }

  function openEditModal(index) {
    const pet = pets[index];
    if (!pet) return;

    editIndexInput.value = index;
    modalTitle.textContent = "Edit Pet";

    nameInput.value = pet.name || "";
    neckInput.value = pet.neck || "";
    birthMonthInput.value = pet.birthMonth || "";
    birthMonthInput.disabled = true;
    birthMonthNote.style.display = "block";
    photoInput.value = "";

    openModal();
  }

  function resizeImage(file, callback) {
    const reader = new FileReader();

    reader.onload = function (e) {
      const img = new Image();

      img.onload = function () {
        const maxWidth = 500;
        const maxHeight = 500;

        let width = img.width;
        let height = img.height;

        if (width > maxWidth || height > maxHeight) {
          const ratio = Math.min(maxWidth / width, maxHeight / height);
          width = Math.round(width * ratio);
          height = Math.round(height * ratio);
        }

        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);

        const compressed = canvas.toDataURL("image/jpeg", 0.75);
        callback(compressed);
      };

      img.src = e.target.result;
    };

    reader.readAsDataURL(file);
  }

  function escapeHtml(str) {
    return String(str || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  addPetBtn.onclick = function () {
    if (pets.length >= petLimit) {
      alert("You can add up to 3 pets for now.");
      return;
    }
    closeModal();
    openModal();
  };

  closeModalBtn.onclick = function () {
    closeModal();
  };

  savePetBtn.onclick = function (event) {
    event.preventDefault();

    const name = nameInput.value.trim();
    const neck = neckInput.value.trim();
    const birthMonth = birthMonthInput.value;
    const file = photoInput.files[0];
    const editIndex = editIndexInput.value;

    if (!name) {
      alert("Add pet name");
      return;
    }

    if (editIndex === "") {
      if (!file) {
        alert("Add photo");
        return;
      }

      if (pets.length >= petLimit) {
        alert("You can add up to 3 pets for now.");
        closeModal();
        return;
      }

      resizeImage(file, async function (compressedPhoto) {
        try {
          pets.push({
            id: "pet_" + Date.now(),
            name: name,
            neck: neck,
            birthMonth: birthMonth,
            photo: compressedPhoto,
            items: []
          });

          await savePetsToCustomer();
          renderPets();
          closeModal();
        } catch (e) {
          console.error(e);
          alert("Could not save pet right now.");
        }
      });

      return;
    }

    const index = Number(editIndex);
    const existingPet = pets[index];
    if (!existingPet) return;

    async function finishEdit(photoValue) {
      pets[index] = {
        ...existingPet,
        name: name,
        neck: neck,
        photo: photoValue
      };

      try {
        await savePetsToCustomer();
        renderPets();
        closeModal();
      } catch (e) {
        console.error(e);
        alert("Could not update pet right now.");
      }
    }

    if (file) {
      resizeImage(file, function (compressedPhoto) {
        finishEdit(compressedPhoto);
      });
    } else {
      finishEdit(existingPet.photo);
    }
  };

  loadPets();
})();